import { render, staticRenderFns } from "./ModalFormConfirmEmail.vue?vue&type=template&id=101b0051&scoped=true&"
import script from "./ModalFormConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ModalFormConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b0051",
  null
  
)

export default component.exports